const ARStatesEnum = Object.freeze({
  NOT_STARTED: -1, 
  INITIALIZATION: 0, 
  HIT_TEST_RESULT_FOUND: 1, 
  HIT_TEST_RESULT_LOST: 2, 
  LOADED: 3,
});

export { ARStatesEnum }